import React from 'react'
import LayoutPreview from './LayoutPreview'

/**
 * Isola crash de um mount real.
 * Em erro, mostra a silhueta (LayoutPreview) — mesmo fallback do modo antigo.
 */
export default class DemoErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error) {
    // eslint-disable-next-line no-console
    console.warn('[UiPlayground] mount falhou', this.props.codigo, error)
  }

  render() {
    if (this.state.error) {
      return (
        <div className="ui-pg-mount-failed">
          <p className="ui-pg-mount-failed__msg">
            Componente real quebrou com props stub — mostrando silhueta.
            <code className="d-block mt-1">{String(this.state.error.message || this.state.error)}</code>
          </p>
          <LayoutPreview item={this.props.item} />
        </div>
      )
    }
    return this.props.children
  }
}
